import { useEffect, useState } from "react";
import { api } from "./api";

// Textes éditoriaux administrables (module « Pages du site »).
// Cache module-level : une seule requête par chargement, réutilisée par toutes les pages.
let cache = null;

export function usePageTexts() {
  const [texts, setTexts] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api.get("/page-texts").then((r) => { cache = r.data || {}; setMediaSafe(cache); }).catch(() => setMediaSafe({}));
    function setMediaSafe(v) { setTexts(v); }
  }, []);
  // text(key, fallback) : valeur administrée si présente, sinon libellé d'origine
  const text = (key, fallback) => (texts[key] || "").trim() || fallback;
  return { texts, text };
}
